import { markConverters, getUnsupportedDecorationToTiptap } from './mark-converters.js';
import './marks/anchor-converter.js';
import 'ricos-schema';
import './marks/bold-converter.js';
import './marks/color-converter.js';
import 'ricos-types';
import './marks/font-size-converter.js';
import './marks/italic-converter.js';
import './marks/link-converter.js';
import './marks/mention-converter.js';
import './marks/spoiler-converter.js';
import './marks/underline-converter.js';

const DECORATIONS_TO_MARKS_BY_TYPE = Object.fromEntries(
  [...markConverters].reverse().flatMap((converter) => converter.toTiptap.types.map((type) => [type, converter.toTiptap]))
);
const getDecorationToMarkConverter = (decoration) => DECORATIONS_TO_MARKS_BY_TYPE[decoration.type] || getUnsupportedDecorationToTiptap(decoration);
const decorationsToMarks = (decorations) => decorations.flatMap(
  (decoration) => getDecorationToMarkConverter(decoration).convert(decoration)
);

export { decorationsToMarks };
//# sourceMappingURL=decorations-to-marks.js.map
